import axios from 'axios'

//查询加工厂列表
export function getProcessFactoryList (data) {
  return axios.get(`/manage/processFactory/list`, { params: data })
}


//查询加工厂详情
export function getProcessFactory (data) {
  return axios.get(`/manage/processFactory/queryById`, { params: data } )
}

//新增加工厂
export function addProcessFactory (data) {
  return axios.post(`/manage/processFactory/save`, data)
}

//编辑加工厂
export function updateProcessFactory (data) {
  return axios.post(`/manage/processFactory/edit`, data)
}

//删除加工厂
export function delProcessFactory (data) {
  return axios.delete(`/manage/processFactory/delete`, { params: data })
}



//新增修改
export function modifyProcessFactory (data, action) {
  return axios.post(`/manage/processFactory/${action}`, data)
}

//下拉列表
export function getProcessFactorySelectList (data) {
  return axios.get(`/manage/processFactory/pullDownList`, { params: data })
}

//选择客户列表
export function getDropFactoryList (data) {
  return axios.get(`/manage/processFactory/pullDownList`, { params: data })
}